import * as hookFormDevTools from '@hookform/devtools';

export const DevTool: (typeof hookFormDevTools)['DevTool'] | (() => null) =
    import.meta.env.PROD
        ? function () {
              return null;
          }
        : hookFormDevTools.DevTool;
